import { Drawer } from 'vaul'

const { Trigger: DrawerTrigger } = Drawer

export const Trigger = DrawerTrigger

Trigger.displayName = 'BottomSheet.Trigger'
